import "@aws-amplify/ui-react/styles.css";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import awsExports from "./aws-exports";
import { AuthProvider } from "./contexts/AuthContext";
import { SnackbarProvider } from "notistack";
import { AppRoutes } from "./routes";
import CustomLoginPage from "./auth/Login";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "./hooks/useAuth";

Amplify.configure(awsExports);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function AppContent() {
  const { user, loading, signOut } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e8f4f8 100%)",
        }}
      >
        <CircularProgress sx={{ color: "#008b8b" }} />
      </Box>
    );
  }

  // If user is not authenticated, show custom login page
  if (!user) {
    return <CustomLoginPage />;
  }

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={3000}
      variant="success"
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider user={user} signOut={signOut}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </SnackbarProvider>
  );
}

function App() {
  return <AppContent />;
}

export default App;
